import { render } from "./B2bPagePedidos.vue?vue&type=template&id=68b29e96&scoped=true&lang=pug"
import script from "./B2bPagePedidos.vue?vue&type=script&lang=js"
export * from "./B2bPagePedidos.vue?vue&type=script&lang=js"

import "./B2bPagePedidos.vue?vue&type=style&index=0&id=68b29e96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b29e96"]])

export default __exports__